"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafeMapKeyNotFoundError = exports.SafeMap = void 0;
class SafeMap extends Map {
    assertGet(key) {
        if (!this.has(key)) {
            throw new SafeMapKeyNotFoundError(key);
        }
        return this.get(key);
    }
}
exports.SafeMap = SafeMap;
class SafeMapKeyNotFoundError extends Error {
    constructor(key) {
        super(`Key ${key} not found in safe map`);
        this.key = key;
    }
}
exports.SafeMapKeyNotFoundError = SafeMapKeyNotFoundError;
//# sourceMappingURL=SafeMap.js.map